module.exports = __webpack_public_path__ + "img/20190531162837QQ截图20190527164506.336aaa20.png";